import React, { useState } from "react";
// import Heading from "../Heading";
import Breadcrumbs from "../../../pageProps/Breadcrumbs";
import Pagination2 from "./../../../pageProps/shopPage/Pagination";
import ProductBanner from "../../../pageProps/shopPage/ProductBanner";

const IsiCompare2 = () => {
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const itemsPerPageFromBanner = (itemsPerPage) => {
    setItemsPerPage(itemsPerPage);
  };
  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Products" />
      {/* ================= Products Start here =================== */}
      <div className="w-full h-full flex pb-20 gap-10">
        <div className=" hidden mdl:inline-flex h-full">
          {/* <ShopSideNav /> */}
        </div>
        <div className="w-full mdl:w-[80%] lgl:w-[100%] h-full flex flex-col gap-10">
          <ProductBanner itemsPerPageFromBanner={itemsPerPageFromBanner} />
          <Pagination2 itemsPerPage={itemsPerPage} />
        </div>
      </div>
      {/* ================= Products End here ===================== */}
    </div>
  );
};

export default IsiCompare2;
